var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 96,
    viewBox: "0 0 102 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.125 0L29 3.125V12.6687C31.0771 12.4416 33.1729 12.4416 35.25 12.6687V6.25H91.5V37.5H80.8313L72.75 45.5813V37.5H60.0812C60.3084 39.5771 60.3084 41.6729 60.0812 43.75H66.5V53.125L71.8375 55.3375L83.4187 43.75H94.625L97.75 40.625V3.125L94.625 0H32.125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1062 58.9315C48.0474 56.3514 51.0505 52.5681 52.6687 48.1442C54.2869 43.7203 54.4339 38.8922 53.0877 34.3781C51.7416 29.8639 48.9742 25.9049 45.1973 23.09C41.4203 20.275 36.8356 18.7544 32.125 18.7544C27.4144 18.7544 22.8297 20.275 19.0527 23.09C15.2758 25.9049 12.5084 29.8639 11.1623 34.3781C9.81609 38.8922 9.96306 43.7203 11.5813 48.1442C13.1995 52.5681 16.2026 56.3514 20.1437 58.9315C15.3165 61.2044 11.2354 64.8036 8.37686 69.3089C5.51833 73.8142 4.0003 79.0396 4 84.3752L4 87.5002H10.25V84.3752C10.4418 78.7016 12.8305 73.3244 16.9119 69.3787C20.9933 65.433 26.4481 63.2273 32.125 63.2273C37.8019 63.2273 43.2567 65.433 47.3381 69.3787C51.4195 73.3244 53.8082 78.7016 54 84.3752V87.5002H60.25V84.3752C60.2497 79.0396 58.7317 73.8142 55.8731 69.3089C53.0146 64.8036 48.9335 61.2044 44.1062 58.9315ZM32.125 56.2502C27.981 56.2502 24.0067 54.604 21.0765 51.6737C18.1462 48.7435 16.5 44.7692 16.5 40.6252C16.5 36.4812 18.1462 32.5069 21.0765 29.5767C24.0067 26.6464 27.981 25.0002 32.125 25.0002C36.269 25.0002 40.2433 26.6464 43.1735 29.5767C46.1038 32.5069 47.75 36.4812 47.75 40.6252C47.75 44.7692 46.1038 48.7435 43.1735 51.6737C40.2433 54.604 36.269 56.2502 32.125 56.2502Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_36",
    x: 0,
    y: 0,
    width: 101.75,
    height: 95.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_36"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_36",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.dd65bc2abc930f055b30619fc1ab3985.svg";
export { ForwardRef as ReactComponent };